var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertaAtencao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0007 3.66671C9.63685 3.66671 3.66732 9.63624 3.66732 17C3.66732 24.3638 9.63685 30.3334 17.0007 30.3334C24.3644 30.3334 30.334 24.3638 30.334 17C30.334 9.63624 24.3644 3.66671 17.0007 3.66671ZM0.333984 17C0.333984 7.79529 7.79591 0.333374 17.0007 0.333374C26.2054 0.333374 33.6673 7.79529 33.6673 17C33.6673 26.2048 26.2054 33.6667 17.0007 33.6667C7.79591 33.6667 0.333984 26.2048 0.333984 17ZM17.0007 10.3334C17.9211 10.3334 18.6673 11.0796 18.6673 12V18.6667C18.6673 19.5872 17.9211 20.3334 17.0007 20.3334C16.0802 20.3334 15.334 19.5872 15.334 18.6667V12C15.334 11.0796 16.0802 10.3334 17.0007 10.3334ZM17.0007 22C17.9211 22 18.6673 22.7462 18.6673 23.6667V23.6834C18.6673 24.6039 17.9211 25.35 17.0007 25.35C16.0802 25.35 15.334 24.6039 15.334 23.6834V23.6667C15.334 22.7462 16.0802 22 17.0007 22Z",
    fill: "#FAB005"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaAtencao);
export default __webpack_public_path__ + "static/media/alerta_atencao.3150999d27d6e085c2f76359abaf1040.svg";
export { ForwardRef as ReactComponent };